<template>
  <div>
    <div class="panel-info-section">
      <div class="panel-info-section-title">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">项目预算明细表</span>
      </div>
      <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :loading="loading" :expanded-row-keys.sync="expandedBudgetKeys" :pagination="false" :data-source="budgets" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
        <a-table-column title="序号" data-index="index" :width="60" align="left">
          <template slot-scope="text, record">
            {{ record.no }}
          </template>
        </a-table-column>
        <a-table-column title="费用名称" data-index="name" :ellipsis="true" :width="280" align="left">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ record.name || '-' }}</span>
          </template>
        </a-table-column>
        <a-table-column title="费用分类" data-index="cate" :width="250">
          <template slot-scope="text, record">
            <template v-if="!record.isRoot && !record.sum">
              {{ record.cateFullName }}
            </template>
          </template>
        </a-table-column>
        <a-table-column title="费用年份" data-index="year" :width="90" align="center" :ellipsis="true">
          <template slot-scope="text, record">
            <template v-if="!record.isRoot">{{ record.year || '-' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="单价" data-index="price" :width="120" align="right" :ellipsis="true">
          <template slot-scope="text, record">
            <template v-if="!record.isRoot">{{ record.price ? $utils.thousands(record.price) : '-' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="数量" data-index="quantity" :width="90" align="right">
          <template slot-scope="text, record">
            <template v-if="!record.isRoot">{{ record.quantity || '-' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="预算金额" data-index="amount" :width="125" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.amount) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="预算备注" data-index="remark" align="left" :width="250">
          <template slot-scope="text, record">
            <div class="lineh-13 text-ellipsis ellipsis-3-lines" v-html="$utils.convertToHtml(record.remark)"></div>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getBudgets } from '@/api/project/common'
import { convertBudgetsToTableData } from '@/utils/data'

export default {
  name: 'ProjectBudget',
  data() {
    return {
      projectId: null,
      loading: false,
      expandedBudgetKeys: [],
      budgets: [],
    }
  },
  methods: {
    load() {
      this.loading = true
      const { add } = this.$utils
      getBudgets(this.projectId).then(({ data }) => {
        if (data.success) {
          let records = convertBudgetsToTableData(data.result)
          let amountTotal = 0
          records.forEach(record => {
            let amount = 0
            if (record.children) {
              record.children.forEach(item => {
                amount = add(amount, item.amount || 0)
              })
            }
            record.amount = amount
            amountTotal = add(amountTotal, amount)
          })
          if (records.length) {
            records.push({
              uid: Math.random(),
              sum: true,
              isRoot: 1,
              name: '合计',
              amount: amountTotal,
            })
          }
          this.budgets = records
          this.expandedBudgetKeys = records.filter(d => d.children && d.children.length).map(d => d.uid)
        }
      })
      this.loading = false
    },
  },
  mounted() {
    let { id } = this.$route.query
    if (id) {
      this.projectId = id
      this.load()
    }
  },
}
</script>
